export const createEmptyColorRow = (overrides = {}) => ({
  name: "",
  name_ur: "",
  color: "",
  color_ur: "",
  colorCode: "#000000",
  price: "",
  weight: "",
  dimension: "",
  unit: "",
  unit_ur: "",
  moq: "",
  position: "",
  existingImages: [],
  newImageFiles: [],
  newImagePositions: [],
  newImageAlts: [],
  newImageTitles: [],
  newImagePrimaryIndex: null,
  existingVariantImage: null,
  variantImageFile: null,
  variantImageAlt: "",
  variantImageTitle: "",
  texture: false,
  existingTextureImage: null,
  textureImageFile: null,
  textureImageAlt: "",
  textureImageTitle: "",
  textureCode: "",
  ...overrides,
});

export const initialFormData = {
  categoryIds: [],
  name: "",
  productName_ur: "",
  customUrl: "",
  description: "",
  description_ur: "",
  shortDescription: "",
  shortDescription_ur: "",
  status: "true",
  colors: [],
  currency: "",
  brandId: "",
  dealership: "authorizedDealer",
  dealership_ur: "مجاز ڈیلر",
  singleVarinet: false,
  weight: "",
  unit: "",
  unit_ur: "",
  price: "",
  dimensions: "",
  moq: "",
  technicalDataSheet: null,
  existingTechnicalDataSheet: null,
};
